import { Component, OnInit, Inject, Optional, Input } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LanguageService } from '../../shared/services/language.service';
import { GCMService } from '../../shared/services/gcm.service';

@Component({
  standalone: false,
  selector: 'app-scr-import-file-dialog',
  templateUrl: './scr-import-file-dialog.component.html',
  styleUrls: ['./scr-import-file-dialog.component.css']
})

export class ScrImportFileComponent implements OnInit {

  variables: any;
  local_data: any;
  invalidInput: boolean = false;
  errorMessage: string = '';
  formGroup1: any;
  user: any = [];
  roles: any = [];

  file!: File;

  constructor(
    public dialogRef: MatDialogRef<ScrImportFileComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private _formBuilder: FormBuilder,
    private languageService: LanguageService,
    private GCMService: GCMService
  ) {
    this.local_data = { ...data };
  }

  ngOnInit(): void {

    this.languageService.translations$.subscribe((vars: any) => {
      this.variables = vars;
    });


  }

  importFromExcel(event: any) {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      //codigo
      //console.log('Arquivo selecionado:', selectedFile);
    }
  }

  doAction() {
    const formGroup = this.formGroup1.value;
    let valid = true;

    if (!formGroup.roleCtrl) {
      this.invalidInput = true;
      this.errorMessage = this.variables.errorRoleEmpty;
      valid = false;
    }
    else {
      this.invalidInput = false;
    }

    //Pass data
    if (valid) {
      this.GCMService.upload(this.file).subscribe((data: any) => {
        if (data) {
          this.dialogRef.close({ data: formGroup.roleCtrl });
        }
      }
      );
    }
  }

  selectFile(event: any) {
    this.file = event.target.files.item(0);
  }

  uploadFile() {
    if (!this.file) {
      this.invalidInput = true;
      this.errorMessage = this.variables.errorNeedFile;
    }
    else {
      this.GCMService.upload(this.file).subscribe(
        (data: any) => {
          if (data) {
            this.dialogRef.close({ data: data });
          }
        },
        (error: any) => {
          this.invalidInput = true;
          this.errorMessage = this.variables.errorOnFileFormat;
        }
      );

    }
  }

}
